import { render, staticRenderFns } from "./MobileTitleWithBack.vue?vue&type=template&id=c077f904&scoped=true&"
import script from "./MobileTitleWithBack.vue?vue&type=script&lang=js&"
export * from "./MobileTitleWithBack.vue?vue&type=script&lang=js&"
import style0 from "./MobileTitleWithBack.vue?vue&type=style&index=0&id=c077f904&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c077f904",
  null
  
)

export default component.exports